import React, { useEffect, useRef, useState } from 'react';
   import Draggable from 'react-draggable';
import { Link, useSearchParams ,useNavigate} from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
 import toast from 'react-hot-toast';
import LoadingScreen from '../../components/LoadingScreen';
 import getDecryptData from '../../../helper/getDecryptData';
import { useBlogContext } from '../../../fetchdata/BlogContext';

const AccountVideoCall = () => {
  const navigate = useNavigate();

  const decryptdatajson =  getDecryptData();
  
      const currentUserId = decryptdatajson?._id;


    const [searchParams] = useSearchParams();
  const videoId = searchParams.get('videoId');


  const { socket } = useBlogContext();
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const peerRef = useRef(null);
  const [roomID] = useState(videoId);
  const [localStream, setLocalStream] = useState(null);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [remoteOnline, setRemoteOnline] = useState(false);
  const [cameraFacingMode, setCameraFacingMode] = useState('user'); // 'user' or 'environment'
  const [isValidUser, setIsValidUser] = useState(false);

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const initMediaStream = async (facingMode = 'user') => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode },
        audio: true,
      });

      setLocalStream(mediaStream);
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = mediaStream;
        await localVideoRef.current.play();
      }

      const senders = peerRef.current?.getSenders?.() || [];
      mediaStream.getTracks().forEach((track) => {
        const sender = senders.find((s) => s.track.kind === track.kind);
        if (sender) {
          sender.replaceTrack(track);
        } else {
          peerRef.current?.addTrack(track, mediaStream);
        }
      });

    } catch (error) {
      console.error('Failed to access media devices:', error);
      alert('Please allow camera and microphone access.');
    }
  };

  useEffect(() => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      alert('Your browser does not support video/audio access.');
      return;
    }

    let stream;

    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .then((mediaStream) => {
        stream = mediaStream;
        setLocalStream(mediaStream);

        if (localVideoRef.current) {
          localVideoRef.current.srcObject = mediaStream;
          localVideoRef.current
            .play()
            .catch((err) => console.warn("Local video play() failed:", err));
        }

        peerRef.current = new RTCPeerConnection({
          iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
        });

        mediaStream.getTracks().forEach((track) => {
          peerRef.current.addTrack(track, mediaStream);
        });

        peerRef.current.ontrack = (event) => {
          const remoteStream = event.streams[0];
          if (remoteVideoRef.current.srcObject !== remoteStream) {
            remoteVideoRef.current.srcObject = remoteStream;
            remoteVideoRef.current
              .play()
              .catch((err) => console.warn('Remote video play() failed:', err));
          }
        };

        peerRef.current.onicecandidate = (event) => {
          if (event.candidate) {
            socket.emit('ice-candidate', { roomID, candidate: event.candidate });
          }
        };

        socket.emit('join', roomID);
      })
      .catch((error) => {
        console.error('Media device access error:', error);
        alert('Please allow camera and mic access to use video call.');
      });

    socket.on('ready', async () => {
      setRemoteOnline(true);
      const offer = await peerRef.current.createOffer();
      await peerRef.current.setLocalDescription(offer);
      socket.emit('offer', { roomID, offer });
    });

    socket.on('offer', async (offer) => {
      setRemoteOnline(true);
      await peerRef.current.setRemoteDescription(offer);
      const answer = await peerRef.current.createAnswer();
      await peerRef.current.setLocalDescription(answer);
      socket.emit('answer', { roomID, answer });
    });

    socket.on('answer', async (answer) => {
      setRemoteOnline(true);
      await peerRef.current.setRemoteDescription(answer);
    });

    socket.on('ice-candidate', async (data) => {
      try {
        await peerRef.current.addIceCandidate(data);
      } catch (err) {
        console.error('ICE candidate error:', err);
      }
    });

    socket.on('user-left', () => {
      setRemoteOnline(false);
      remoteVideoRef.current.srcObject = null;
    });

    return () => {
      socket.emit('leave', roomID);
      socket.off('ready');
      socket.off('offer');
      socket.off('answer');
      socket.off('ice-candidate');
      socket.off('user-left');

      if (peerRef.current) peerRef.current.close();
      if (stream) stream.getTracks().forEach((track) => track.stop());
    };
  }, [roomID, socket]);

  const toggleVideo = () => {
    if (localStream) {
      const videoTrack = localStream.getVideoTracks()[0];
      videoTrack.enabled = !videoTrack.enabled;
      setVideoEnabled(videoTrack.enabled);
    }
  };

  const toggleAudio = () => {
    if (localStream) {
      const audioTrack = localStream.getAudioTracks()[0];
      audioTrack.enabled = !audioTrack.enabled;
      setAudioEnabled(audioTrack.enabled);
    }
  };

  const [isZoomed, setIsZoomed] = useState(true);

  const handleDoubleClick = () => {
    setIsZoomed((prev) => !prev);
  };

  const switchCamera = async () => {
    if (!localStream) return;
    localStream.getTracks().forEach((track) => track.stop());
    const newFacingMode = cameraFacingMode === 'user' ? 'environment' : 'user';
    setCameraFacingMode(newFacingMode);
    await initMediaStream(newFacingMode);
  };

    const [loading, setLoading] = useState(true);
  
      const [videoData, setVideoData] = useState([]);
 
const fetchData = async () => {
 
  setLoading(true);
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/get-video-call/${videoId}`);
       const  {video} = response.data;

      console.log('response.data',response.data);
      setVideoData(video);
         if (
        currentUserId === video.sender._id ||
        currentUserId === video.receiver._id
      ) {
        setIsValidUser(true);
      } else {
        // alert('You are not authorized to join this call.');
        setIsValidUser(false);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (videoId) {
      fetchData();
    }
  }, [videoId]);
  
const [time, setTime] = useState('00:00:00'); // Store elapsed time

  useEffect(() => {
    const interval = setInterval(() => {
      if (videoData.start && !videoData.end) {
        const start = new Date(videoData.start); // Use videoData.start as the start time
        const now = new Date();
        const diff = Math.floor((now - start) / 1000); // Difference in seconds

        const hrs = String(Math.floor(diff / 3600)).padStart(2, '0');
        const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
        const secs = String(diff % 60).padStart(2, '0');

        // Update the elapsed time
        setTime(`${hrs}:${mins}:${secs}`);
      }
    }, 1000);

    return () => clearInterval(interval); // Clean up interval on unmount
  }, [videoData]); // Re-run when videoData changes



  
    const handleEndVideo = async () => {
    const mydata = {
        orderId: videoData._id,
    };
  
    try {
      // Wrapping the API call in toast.promise properly
      const response = await toast.promise(
        axiosInstance.post("/admin/end-video-call", mydata), {
          loading: "Ending video call...", // Loading message
          success: "Ending video call successfully!", // Success message
          error: "Failed to Ending video call.", // Error message
        }
      );
  
      console.log('Response:', response);
  
      const { success,video } = response.data;
      if (success) {
        navigate(`/account/all-video-call`);
      }
  
    } catch (error) {
      console.error('Error starting video call:', error);
    }
  };


  return (

    <>
 
    {loading ? 
      LoadingScreen  :
                         isValidUser ? <div className="m-0 position-relative p-0 overflow-hidden" id="videocall-box" style={{ height: '100vh', width: '100%' }}>
      <div className="row justify-content-center">
        <Draggable>
          <div className="col-md-2 col-5 mb-3 position-absolute top-0 z-3" id="mycamera">
            <div className="text-center mb-1 ">
              <span className={`badge ${remoteOnline ? 'bg-success' : 'bg-danger'}`}>
                {remoteOnline ? 'Online' : 'Offline'} {time || '00:00:00'}
              </span>
            </div>
            <video
              ref={localVideoRef}
              autoPlay
              muted
              playsInline
              className="w-100 border rounded bg-dark mirror"
            />
          </div>
        </Draggable>

        <div className="col-12">
          {isIOS && (
            <div className="text-center mt-3 d-none">
              <small className="text-muted">
                If video doesn't play automatically on iPhone, tap on the video area to start.
              </small>
            </div>
          )}
          <video
            ref={remoteVideoRef}
            autoPlay
            muted={false}
            playsInline
            className={`w-100 bg-dark mirror ${!isZoomed ? 'zoomed' : ''}`}
            style={{ height: '100vh' }}
            onDoubleClick={handleDoubleClick}
          />
        </div>
      </div>

      <div className="text-center mt-3 position-fixed d-flex gap-4 fs-4 fw-light text-white" id="call-buttons">
        <button onClick={toggleVideo} className="border-0 p-0 bg-transparent text-white">
          {videoEnabled ? (<i className="ri-video-on-line" />) : (<i className="ri-video-off-line" />)}
        </button>
        <button onClick={toggleAudio} className="border-0 p-0 bg-transparent text-white">
          {audioEnabled ? (<i className="ri-volume-up-line" />) : (<i className="ri-volume-mute-line" />)}
        </button>

        <button onClick={switchCamera} className="border-0 p-0 bg-transparent text-white">
          <i className="ri-camera-switch-line" />
        </button>

        <button    onClick={handleEndVideo} className="border-0 p-0 bg-transparent text-white border-danger">
          <img src="/assets/img/call-end.svg" width={40} height={40} />
        </button>
      </div>
    </div> : 
    <div className='d-flex justify-content-center vh-100 align-items-center'>
      <div className='text-center'>

      <svg
  width="100px"
  height="100px"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  type='button'


>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.31171 10.7615C8.23007 5.58716 9.68925 3 12 3C14.3107 3 15.7699 5.58716 18.6883 10.7615L19.0519 11.4063C21.4771 15.7061 22.6897 17.856 21.5937 19.428C20.4978 21 17.7864 21 12.3637 21H11.6363C6.21356 21 3.50217 21 2.40626 19.428C1.31034 17.856 2.52291 15.7061 4.94805 11.4063L5.31171 10.7615ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
    fill="#d22347"
  />
</svg>


      <div className="text-center text-danger mt-2">Unauthorized user for this video call.</div>
      <Link to={'/'} className='btn btn-primary text-white mt-3 d-inline-block px-3'> Go Home</Link>
      </div>
      
      </div>
                        }
       </>
  );
};

export default AccountVideoCall;
